import { AxiosError } from 'axios';
import React, { useEffect } from 'react';
import TwoFactorAuthCodeForm from '../../../components/v2/Auth/TwoFactorAuthCodeForm';
import { useModal } from '../../../components/v2/Modal/useModal';
import { useTranslation } from 'utils/translation';
import http from '../../../utils/http';
import Listener from '../2fa/listener';
import * as Types from '../2fa/types';
import { resend2faCode } from '../service/api';
import { ERROR_2FA_CANCELED } from '../2fa/const';

const TwoFactorProvider = ({ children }: React.PropsWithChildren) => {
  const modal = useModal();
  const { t } = useTranslation();

  useEffect(() => {
    const handler = (provider: Types.TwoFactorProvider) => {
      return new Promise<any>((resolve, reject) => {
        const cancel2fa = () => {
          reject(ERROR_2FA_CANCELED);
        };

        const onCancel = () => {
          cancel2fa();
          modal.close(Component);
        };

        const onSuccess = (result: any) => {
          resolve(result);
          modal.close(Component);
        };

        const verification = async (code: string) => {
          try {
            return await http.post('/token/2fa_check', {
              _auth_code: code,
            });
          } catch (error: AxiosError | any) {
            return false;
          }
        };

        const Component = () => (
          <TwoFactorAuthCodeForm
            suppressHeading
            provider={provider}
            verification={verification}
            onSuccess={onSuccess}
            onCancel={onCancel}
            onResend={resend2faCode}
          />
        );

        modal.open(Component, {
          title: t('2fa_code_from_title'),
          onClose: cancel2fa,
          disableBackdropClose: true,
        });
      });
    };

    Listener.registerProvider('email', () => handler('email'));
    Listener.registerProvider('totp', () => handler('totp'));
  }, []);

  return children;
};

export default TwoFactorProvider;
